import React, { useEffect } from "react"
import { useState } from "react"
import { FiSearch } from "react-icons/fi"
import InputWithIcon from "components/NavbarInput"

const WithSearch = ({
  handleSearch,
  setOpenSearch = () => {},
  openSearch = false,
}) => {
  const [search, setSearch] = useState("")
  useEffect(() => {
    handleSearch("search", search)
  }, [search])

  const handleClose = () => {
    setSearch("")
    setOpenSearch(false)
  }

  return (
    <div className="relative flex items-center justify-center w-full gap-3">
      <InputWithIcon
        className={openSearch ? "w-full h-full" : "border-0"}
        name="Қидирув"
        label="Қидирув"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        decoration={<FiSearch size="1rem" aria-hidden="true" />}
        clickIconButton={() => console.log("hello")}
        setOpenSearch={handleClose}
        openSearch={openSearch}
      />
    </div>
  )
}

export default WithSearch
